/*
 * Copyright (c) 2020. American Express Company
 */

import * as _ from 'lodash';

export default class LocalStorageService {
    public static localStorageSupported: boolean =
        typeof window !== 'undefined' && typeof window.localStorage !== 'undefined' && window.localStorage != null;

    private static unsupportedError(): void {
        console.error('LocalStorage is not supported in this browser.');
    }

    public static get(key: string): string | null {
        if (this.localStorageSupported) {
            return localStorage.getItem(key);
        } else {
            this.unsupportedError();
            return null;
        }
    }

    public static set(key: string, item: string): boolean {
        if (this.localStorageSupported) {
            localStorage.setItem(key, item);
            return true;
        } else {
            this.unsupportedError();
            return false;
        }
    }

    public static remove(key: string): void {
        localStorage.removeItem(key);
    }

    public static clear(): void {
        localStorage.clear();
    }

    public static keys(): string[] {
        return _.range(localStorage.length).map((i) => localStorage.key(i));
    }
}
